export default __webpack_public_path__ + "static/media/1.f9e7afa8.jpg";